import { render, staticRenderFns } from "./BandejaComponenteSolicitudes.vue?vue&type=template&id=50fe96da&scoped=true"
import script from "./BandejaComponenteSolicitudes.vue?vue&type=script&lang=js"
export * from "./BandejaComponenteSolicitudes.vue?vue&type=script&lang=js"
import style0 from "./BandejaComponenteSolicitudes.vue?vue&type=style&index=0&id=50fe96da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fe96da",
  null
  
)

export default component.exports